import { useState } from 'react'

import { Expanded } from '../expanded/Expanded'

import { IRowProps } from './models'

export function Row({
  rowAttrs,
  renderChildren,
  item,
  rowState,
  additional,
  colsNumber,
  openPartnerDialog,
}: IRowProps) {
  const [opened, setOpened] = useState<boolean>(false)
  return (
    <>
      <tr {...rowAttrs} key={item.get('PartnerID')} onClick={() => setOpened(!opened)}>
        {renderChildren(item, rowState, additional)}
      </tr>
      {opened && (
        <tr>
          <td colSpan={colsNumber}>
            <Expanded
              partnerId={item.get('PartnerID')}
              partner={item}
              openPartnerDialog={openPartnerDialog}
            />
          </td>
        </tr>
      )}
    </>
  )
}
